const SESSION_UPDATED_EVENT = "session-token-updated";
const SESSION_EXPIRED_EVENT = "session-expired";

const SESSION_STORAGE_KEYS = [
  "token",
  "user",
  "cdemp",
  "cidemp",
  "estemp",
  "baiemp",
  "tipoemp",
];

const decodeBase64Url = (value) => {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(
    normalized.length + ((4 - (normalized.length % 4)) % 4),
    "=",
  );

  try {
    return window.atob(padded);
  } catch (error) {
    return "";
  }
};

const parseJwtPayload = (token) => {
  if (!token || typeof token !== "string") {
    return null;
  }

  const parts = token.split(".");
  if (parts.length < 2) {
    return null;
  }

  const decodedPayload = decodeBase64Url(parts[1]);
  if (!decodedPayload) {
    return null;
  }

  try {
    return JSON.parse(decodedPayload);
  } catch (error) {
    return null;
  }
};

export const getTokenExpirationTime = (token) => {
  const payload = parseJwtPayload(token);
  const exp = Number(payload?.exp);

  if (!Number.isFinite(exp) || exp <= 0) {
    return null;
  }

  return exp * 1000;
};

export const isPublicPath = (pathname = window.location.pathname) =>
  pathname === "/" || pathname === "/login";

export const clearSessionData = () => {
  SESSION_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const notifySessionTokenUpdated = () => {
  window.dispatchEvent(new Event(SESSION_UPDATED_EVENT));
};

export const expireSession = () => {
  clearSessionData();
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
};

export const redirectToLogin = () => {
  if (window.location.pathname !== "/login") {
    window.location.assign("/login");
  }
};

export { SESSION_EXPIRED_EVENT, SESSION_UPDATED_EVENT };
